import Util from '../util';

const url = '/api/colorcalc/user_products_units';
const Api = {
  /**
   * @param {object} params
   */
  deleteAsync({ unitId }) {
    const segment = `/${unitId}`;
    return fetch(`${Util.apiSegment}${url}${segment}`, {
      method: 'DELETE'
    }).then(response => response.json());
  },
  getAsync() {
    return fetch(`${Util.apiSegment}${url}`).then(response => response.json());
  },
};
export default Api;
